import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { useSelector } from "react-redux";
import { selectSiteLang } from "../../../store/userSlice";
import "swiper/swiper.min.css";
import "./pagination.css";
import style from "./index.module.css";

SwiperCore.use([Autoplay, Pagination]);

const Banner = ({ banners, bannerStyle, redirection }: ComponentPropsType) => {
  const siteLang = useSelector(selectSiteLang);

  return (
    <Swiper
      className="banners_slider"
      dir={siteLang === "ar" ? "rtl" : "ltr"}
      {...(banners.length > 1
        ? {
            pagination: {
              clickable: true,
            },
          }
        : {})}
      autoplay={{
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }}
    >
      {banners.map((banner, index) => (
        <SwiperSlide key={index} className={`${style.banner} ${style[bannerStyle]}`}>
          <a href={banner.url} target={redirection === "newPage" ? "_blank" : "_self"} rel="noreferrer">
            <img src={banner.image} alt="" />
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Banner;

type ComponentPropsType = {
  bannerStyle: "big" | "small" | "square";
  banners: {
    image: string;
    url: string;
  }[];
  redirection: "samePage" | "newPage";
};
